import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  Modal2,
  ResolvableModal,
  Validators,
  WithModal } from '@softline/ui-core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { RohstoffbereitstellungQuery } from '../../services/query.service';

import { DateInputComponent } from '@softline/ui-core/date-input';
@Component({
  selector: 'soft-rohstoffbereitstellung-edit-zeitraum-form-dialog',
  imports: [ReactiveFormsModule],
  templateUrl: './edit-zeitraum-form-dialog.component.html',
  styleUrl: './edit-zeitraum-form-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class EditZeitraumFormDialogComponent extends ResolvableModal<
  Omit<RohstoffbereitstellungQuery, 'artikel'>
> {
  readonly form = new FormGroup({
    vondatum: new FormControl<string | null>(null, Validators.required()),
    bisdatum: new FormControl<string | null>(null, Validators.required()) });

  set vondatum(value: string | null) {
    this.form.patchValue({ vondatum: value });
  }

  set bisdatum(value: string | null) {
    this.form.patchValue({ bisdatum: value });
  }

  constructor() {
    super();
  }
}
